export enum HeaderBG {
  INSIDERSBG = 'insidersBG',
  TRANSPARENTBG = 'transparentBG',
  WHITEBG = 'whiteBG',
}
